<p-tabView>
  <p-tabPanel header="Usuário">
    <div class="p-col-12">
      <p-card header="Usuário: {{ usuario?.nome }}">
        <div class="p-fluid">
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
            <div class="p-col-12 p-md-10">{{ usuario?.id }}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome: </label>
            <div class="p-col-12 p-md-10" title="Nome: {{ usuario?.nome }}">{{ usuario?.nome }}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Tipo: </label>
            <div class="p-col-12 p-md-10" title="Tipo: {{ usuario?.tipo }}">{{ usuario?.tipo }}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Login: </label>
            <div class="p-col-12 p-md-10" title="Login: {{ usuario?.login }}">{{ usuario?.login }}</div>
          </div>
        </div>
        <ng-template pTemplate="footer">
         <div class="p-grid">
          <div *ngIf="usuario.tipo === 'SISTEMA'" (click)="abrirModalAlteracaoSenha()" class="p-col-6">
            <button pButton class="p-button-secondary  p-lg-12" label="Alterar Senha"></button>
          </div>
          <div [className]="usuario.tipo === 'SISTEMA' ? 'p-col-6' : 'p-col-12'">
            <button pButton appBotaoVoltar class="p-button-primary  p-lg-12" label="Voltar"></button>
          </div>
         </div>
        </ng-template>
      </p-card>
    </div>
  </p-tabPanel>
  <p-tabPanel header="Auditoria" [disabled]="usuario.id === undefined">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Data:</div>
        <div class="p-col-12 p-lg-9">{{ usuario.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{ usuario.auditoriaUsuarioInsercao?.nome }}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Data:</div>
        <div class="p-col-12 p-lg-9">{{ usuario.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{ usuario.auditoriaUsuario?.nome }}</div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>

<p-dialog
  header="Alterar senha usuário de Sistema"
  [showHeader]="true"
  [visible]="mostrarModalAlteracaoSenha"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{ width: '90%', maxWidth: '800px'}"
  appendTo="body">
  <div style="width: 100%">
    <div style="text-align: center; margin: 1em 0">
      <p>Digite uma nova senha para o usuário de sistema:</p>
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="senha">Senha:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="password" name="novaSenha" [(ngModel)]="novaSenha" />
          </div>
        </div>
      </div>
      <div style="margin: 1em 0">
        <button (click)="fecharModalAlteracaoSenha()" pButton type="button" label="Cancelar" class="p-button-danger" style="margin-right: 8px;"></button>
        <button (click)="alterarSenhaUsuarioSistema()" pButton type="button" [disabled]="!novaSenha || !novaSenha.trim() || carregando">
          <span *ngIf="!carregando">Salvar</span>
          <span *ngIf="carregando" class="pi pi pi-spin pi-spinner"></span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>
